export const manSVG = (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.89449 7.84473C8.18074 8.53102 7.24738 8.9428 6.23167 8.9428C5.21596 8.9428 4.2826 8.53102 3.56885 7.84473C2.03155 8.42121 0.960938 9.90361 0.960938 11.6331V13.0606C0.960938 13.3076 1.1531 13.4998 1.40017 13.4998H11.0632C11.3102 13.4998 11.5024 13.3076 11.5024 13.0606V11.6331C11.5024 9.90361 10.4043 8.42121 8.89449 7.84473Z"
      fill="#00086D"
    />
    <path
      d="M3.1321 4.77031C3.1321 6.60958 4.53214 8.11942 6.23414 8.11942C7.93615 8.11942 9.33619 6.60958 9.33619 4.77031C9.33619 4.6056 9.33619 4.41344 9.30874 4.24873C9.80287 2.79379 9.5558 0.130971 8.62244 0.542747C7.79889 0.899619 3.29681 -0.253353 3.54388 1.66827C2.47326 1.69572 3.04974 3.78205 3.15955 4.24873C3.15955 4.41344 3.1321 4.57815 3.1321 4.77031ZM4.09291 4.85267C4.20272 4.85267 4.31252 4.77031 4.28507 4.66051C4.23017 4.16637 4.12036 2.90359 4.55959 3.0134C5.10862 3.15066 5.71256 3.31537 6.23414 3.31537C6.75573 3.31537 7.35966 3.15066 7.9087 3.0134C8.34793 2.90359 8.23812 4.13892 8.18322 4.66051C8.15576 4.77031 8.26557 4.88012 8.37538 4.85267L8.56754 4.82522C8.54009 6.22525 7.49692 7.32332 6.23414 7.32332C4.97136 7.32332 3.95565 6.1978 3.90075 4.82522L4.09291 4.85267Z"
      fill="#00086D"
    />
  </svg>
);
export const girlSVG = (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7433_49154)">
      <path
        d="M10.811 9.39453C10.3344 9.42857 9.89182 9.46262 9.44927 9.46262H9.34714C8.5982 10.0754 7.74714 10.3818 6.96416 10.3818C6.14714 10.3818 5.29608 10.0413 4.58118 9.46262H4.5131C4.07054 9.46262 3.62799 9.42857 3.1514 9.39453C1.68757 10.2116 0.734375 11.7775 0.734375 13.5818V15.2839C0.734375 15.5562 0.972673 15.7945 1.24501 15.7945H12.7514C13.0237 15.7945 13.262 15.5562 13.262 15.2839V13.5818C13.228 11.8116 12.2748 10.2456 10.811 9.39453Z"
        fill="#00086D"
      />
      <path
        d="M1.85868 8.23822C2.70974 8.37439 3.7991 8.47652 4.92251 8.44247C5.53527 9.0212 6.28421 9.36162 6.96506 9.36162C7.64591 9.36162 8.3608 9.0212 9.00761 8.44247C10.131 8.47652 11.2204 8.37439 12.0714 8.23822C12.3778 8.20418 12.4459 7.76162 12.1736 7.62545C11.5268 7.28503 10.88 6.57013 10.88 5.07226C10.88 0.476516 8.12251 -0.102208 6.96506 0.442473C5.80761 -0.102208 3.05017 0.476516 3.05017 5.07226C3.05017 6.57013 2.4374 7.28503 1.75655 7.62545C1.48421 7.79567 1.55229 8.20418 1.85868 8.23822ZM4.47995 4.76588C5.60336 4.69779 7.16931 4.11907 8.05442 3.06375C8.32676 3.67652 8.8374 4.18715 9.45016 4.42545C9.48421 4.69779 9.48421 4.97013 9.48421 5.27652C9.48421 7.04673 7.95229 8.47652 6.96506 8.47652C5.97782 8.47652 4.44591 7.04673 4.44591 5.27652C4.44591 5.1063 4.44591 4.93609 4.47995 4.76588Z"
        fill="#00086D"
      />
    </g>
    <defs>
      <clipPath id="clip0_7433_49154">
        <rect
          width="12.9362"
          height="16"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const editSVG = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9152 2.16475C11.8097 2.05926 11.6666 2 11.5174 2C11.3683 2 11.2252 2.05926 11.1197 2.16475L4.22541 9.05904C4.15474 9.12971 4.10418 9.21794 4.07892 9.31463L3.32892 12.186C3.27845 12.3792 3.3342 12.5847 3.47541 12.7259C3.61662 12.8671 3.8221 12.9228 4.01532 12.8724L6.88663 12.1224C6.98333 12.0971 7.07156 12.0465 7.14223 11.9759L14.0365 5.08157C14.2562 4.8619 14.2562 4.50574 14.0365 4.28607L11.9152 2.16475ZM5.12883 9.74662L11.5174 3.358L12.8433 4.68382L6.45465 11.0724L4.66008 11.5412L5.12883 9.74662Z"
      fill="#00086D"
    />
    <path
      d="M3.5625 14C3.25184 14 3 14.2518 3 14.5625C3 14.8732 3.25184 15.125 3.5625 15.125H14.8125C15.1232 15.125 15.375 14.8732 15.375 14.5625C15.375 14.2518 15.1232 14 14.8125 14H3.5625Z"
      fill="#00086D"
    />
  </svg>
);
export const deleteSVG = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 1.6875C7.93934 1.6875 7.6875 1.93934 7.6875 2.25V2.8125H4.5C4.18934 2.8125 3.9375 3.06434 3.9375 3.375C3.9375 3.68566 4.18934 3.9375 4.5 3.9375H15C15.3107 3.9375 15.5625 3.68566 15.5625 3.375C15.5625 3.06434 15.3107 2.8125 15 2.8125H11.8125V2.25C11.8125 1.93934 11.5607 1.6875 11.25 1.6875H8.25Z"
      fill="#C43535"
    />
    <path
      d="M10.5455 11.25L11.6477 12.3522C11.8674 12.5719 11.8674 12.9281 11.6477 13.1477C11.4281 13.3674 11.0719 13.3674 10.8523 13.1477L9.75001 12.0455L8.64775 13.1477C8.42808 13.3674 8.07193 13.3674 7.85226 13.1477C7.63259 12.9281 7.63259 12.5719 7.85226 12.3523L8.95451 11.25L7.85225 10.1477C7.63258 9.92807 7.63258 9.57192 7.85225 9.35225C8.07192 9.13258 8.42808 9.13258 8.64775 9.35225L9.75001 10.4545L10.8523 9.35225C11.0719 9.13258 11.4281 9.13258 11.6478 9.35225C11.8674 9.57192 11.8674 9.92808 11.6478 10.1477L10.5455 11.25Z"
      fill="#C43535"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.24357 5.93788C5.27522 5.65301 5.51601 5.4375 5.80263 5.4375H13.6974C13.984 5.4375 14.2248 5.65301 14.2564 5.93788L14.4065 7.28889C14.6786 9.73788 14.6786 12.2095 14.4065 14.6585L14.3918 14.7915C14.2837 15.7636 13.5303 16.5387 12.5617 16.6743C10.6963 16.9355 8.80367 16.9355 6.93831 16.6743C5.96966 16.5387 5.21625 15.7636 5.10823 14.7915L5.09346 14.6585C4.82135 12.2095 4.82135 9.73788 5.09346 7.28889L5.24357 5.93788ZM6.30609 6.5625L6.21158 7.41313C5.94864 9.77955 5.94864 12.1678 6.21158 14.5342L6.22635 14.6672C6.27758 15.1283 6.63489 15.4959 7.09429 15.5602C8.85617 15.8069 10.6438 15.8069 12.4057 15.5602C12.8651 15.4959 13.2224 15.1283 13.2736 14.6672L13.2884 14.5342C13.5514 12.1678 13.5514 9.77955 13.2884 7.41313L13.1939 6.5625H6.30609Z"
      fill="#C43535"
    />
  </svg>
);
export const phoneSVG = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.8795 7.39213C6.21999 10.311 8.60535 12.6317 11.5707 13.8891L11.58 13.8931L12.1529 14.1484C12.8824 14.4734 13.7398 14.2426 14.2075 13.5953L15.1633 12.2725C15.2216 12.1917 15.2066 12.0793 15.129 12.0167L13.4605 10.6706C13.3775 10.6037 13.2555 10.6193 13.1921 10.7049L12.5427 11.5812C12.385 11.794 12.1002 11.868 11.8588 11.7588C9.64154 10.7553 7.85976 8.97354 6.85631 6.75624C6.7471 6.51492 6.82105 6.23011 7.03386 6.0724L7.91015 5.423C7.99577 5.35955 8.01136 5.23758 7.94444 5.15463L6.59816 3.48585C6.53559 3.40829 6.42328 3.39322 6.34248 3.45155L5.01251 4.41167C4.36092 4.88206 4.13145 5.74669 4.46405 6.47828L4.87905 7.39115C4.8792 7.39148 4.87935 7.3918 4.8795 7.39213ZM11.1267 14.9228C7.90472 13.5551 5.3132 11.0329 3.85667 7.86057L3.85579 7.85866L3.43991 6.94387C2.88559 5.72456 3.26803 4.28351 4.35402 3.49952L5.68399 2.5394C6.24958 2.1311 7.03575 2.23655 7.47375 2.77947L8.82003 4.44825C9.28845 5.02888 9.17935 5.88268 8.57998 6.32686L8.07785 6.69897C8.92604 8.34477 10.2703 9.68905 11.9161 10.5372L12.2882 10.0351C12.7324 9.43574 13.5862 9.32664 14.1668 9.79505L15.8354 11.1411C16.3785 11.5793 16.4838 12.3658 16.0751 12.9313L15.1194 14.2542C14.3399 15.333 12.9108 15.7177 11.6951 15.176L11.1267 14.9228Z"
      fill="#9999A7"
    />
  </svg>
);
export const emailSVG = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.37066 5.56878C2.18389 7.30405 2.19222 9.30537 2.4521 11.0336C2.5959 11.9898 3.37635 12.7229 4.33973 12.8067L5.34655 12.8942C7.44591 13.0767 9.55715 13.0767 11.6565 12.8942L12.6633 12.8067C13.6267 12.7229 14.4072 11.9898 14.551 11.0336C14.8108 9.30536 14.8192 7.30416 14.6324 5.56889C14.6083 5.36771 14.5811 5.16681 14.551 4.96624C14.4072 4.00998 13.6267 3.27689 12.6633 3.19314L11.6565 3.10562C9.55715 2.92313 7.44591 2.92313 5.34655 3.10562L4.33972 3.19314C3.37635 3.27689 2.5959 4.00998 2.4521 4.96624C2.42195 5.16677 2.3948 5.36764 2.37066 5.56878ZM5.43315 4.10186C7.47489 3.92438 9.52817 3.92438 11.5699 4.10186L12.5767 4.18938C13.0796 4.2331 13.487 4.61578 13.5621 5.11495C13.5699 5.16679 13.5775 5.21865 13.5848 5.27053L9.8775 7.33016C9.02177 7.80557 7.98125 7.80557 7.12552 7.33016L3.41823 5.27056C3.4256 5.21866 3.43319 5.16679 3.44098 5.11495C3.51605 4.61578 3.92344 4.2331 4.42633 4.18938L5.43315 4.10186ZM13.7072 6.34651C13.8365 7.85834 13.7881 9.38158 13.5621 10.8849C13.487 11.3841 13.0796 11.7667 12.5767 11.8104L11.5699 11.898C9.52818 12.0755 7.47489 12.0755 5.43315 11.898L4.42633 11.8104C3.92344 11.7667 3.51605 11.3841 3.44098 10.8849C3.21492 9.38159 3.16655 7.85836 3.29586 6.34653L6.63988 8.20432C7.79763 8.84752 9.20539 8.84752 10.3631 8.20432L13.7072 6.34651Z"
      fill="#9999A7"
    />
  </svg>
);
export const timeSVG = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16927 2.01172C6.89312 2.01172 6.66927 1.78786 6.66927 1.51172C6.66927 1.23558 6.89312 1.01172 7.16927 1.01172H9.52629C9.80243 1.01172 10.0263 1.23558 10.0263 1.51172C10.0263 1.78786 9.80243 2.01172 9.52629 2.01172H7.16927Z"
      fill="#9999A7"
    />
    <path
      d="M4.85616 2.31299C5.05142 2.50825 5.05142 2.82483 4.85616 3.02009L3.18949 4.68676C2.99423 4.88202 2.67765 4.88202 2.48238 4.68676C2.28712 4.4915 2.28712 4.17492 2.48238 3.97965L4.14905 2.31299C4.34431 2.11773 4.6609 2.11773 4.85616 2.31299Z"
      fill="#9999A7"
    />
    <path
      d="M8.5026 3.83321C5.83323 3.83321 3.66927 5.99716 3.66927 8.66654C3.66927 11.3359 5.83323 13.4999 8.5026 13.4999C11.172 13.4999 13.3359 11.3359 13.3359 8.66654C13.3359 8.3904 13.5598 8.16654 13.8359 8.16654C14.1121 8.16654 14.3359 8.3904 14.3359 8.66654C14.3359 11.8882 11.7243 14.4999 8.5026 14.4999C5.28094 14.4999 2.66927 11.8882 2.66927 8.66654C2.66927 5.44488 5.28094 2.83321 8.5026 2.83321C8.77875 2.83321 9.0026 3.05707 9.0026 3.33321C9.0026 3.60935 8.77875 3.83321 8.5026 3.83321Z"
      fill="#9999A7"
    />
    <path
      d="M11.9614 5.57605C12.1162 5.377 12.0986 5.09383 11.9203 4.91552C11.742 4.73722 11.4588 4.71959 11.2598 4.8744L9.14649 6.51805L7.76554 7.50445C7.47056 7.71515 7.2955 8.05534 7.2955 8.41784C7.2955 9.03776 7.79804 9.54031 8.41797 9.54031C8.78047 9.54031 9.12066 9.36524 9.33136 9.07026L10.3178 7.68932L11.9614 5.57605Z"
      fill="#9999A7"
    />
  </svg>
);
export const locationSVG = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8523 5.64612C11.0475 5.84138 11.0475 6.15797 10.8523 6.35323L8.51894 8.68656C8.32367 8.88182 8.00709 8.88182 7.81183 8.68656L6.47849 7.35323C6.28323 7.15797 6.28323 6.84138 6.47849 6.64612C6.67376 6.45086 6.99034 6.45086 7.1856 6.64612L8.16538 7.6259L10.1452 5.64612C10.3404 5.45086 10.657 5.45086 10.8523 5.64612Z"
      fill="#9999A7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.84829 5.90424C3.08451 3.0385 5.47928 0.833008 8.35474 0.833008H8.6427C11.5182 0.833008 13.9129 3.0385 14.1491 5.90424C14.276 7.44367 13.8005 8.97227 12.8227 10.1681L9.62737 14.0759C9.04403 14.7893 7.9534 14.7893 7.37006 14.0759L4.17469 10.1681C3.19692 8.97227 2.7214 7.44367 2.84829 5.90424ZM8.35474 1.83301C5.99971 1.83301 4.03837 3.63933 3.84491 5.98639C3.7393 7.26762 4.13506 8.53983 4.94884 9.53505L8.14421 13.4429C8.32743 13.667 8.67 13.667 8.85322 13.4429L12.0486 9.53505C12.8624 8.53983 13.2581 7.26762 13.1525 5.98639C12.9591 3.63933 10.9977 1.83301 8.6427 1.83301H8.35474Z"
      fill="#9999A7"
    />
  </svg>
);
export const pinedSVG = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6879 2.48361C11.1042 1.89998 10.1157 2.09036 9.79056 2.84899L8.72883 5.32635C7.72945 5.13037 6.65273 5.41908 5.87746 6.19435L4.7374 7.33441C4.54213 7.52967 4.54213 7.84625 4.7374 8.04152L6.40094 9.70505L2.81051 13.2955C2.61525 13.4907 2.61525 13.8073 2.81051 14.0026C3.00577 14.1978 3.32235 14.1978 3.51762 14.0026L7.10804 10.4122L8.77164 12.0758C8.8654 12.1695 8.99258 12.2222 9.12519 12.2222C9.2578 12.2222 9.38497 12.1695 9.47874 12.0758L10.6188 10.9357C11.3941 10.1604 11.6828 9.08369 11.4868 8.0843L13.9641 7.02258C14.7228 6.69745 14.9132 5.70892 14.3295 5.12529L11.6879 2.48361ZM10.7097 3.24291C10.7562 3.13454 10.8974 3.10734 10.9807 3.19072L13.6224 5.8324C13.7058 5.91577 13.6786 6.05699 13.5702 6.10344L10.6933 7.33639C10.4504 7.44049 10.3305 7.71564 10.4195 7.96446C10.6936 8.72999 10.5233 9.61698 9.9117 10.2286L9.12519 11.0151L5.79806 7.68796L6.58457 6.90145C7.19617 6.28985 8.08315 6.1196 8.84868 6.3936C9.0975 6.48266 9.37265 6.36271 9.47675 6.11981L10.7097 3.24291Z"
      fill="#9999A7"
    />
  </svg>
);
